import { get as _get } from 'lodash';
/**
 * lodashのget関数のラッパー
 * @description https://lodash.com/docs/4.17.15#get
 */
export const get = _get;
